<div *ngIf="!showIframe">
  <div class="d-flex justify-content-center p-3 text-white" style="background-color: #292c2e; height: 60px; font-size: 26px">
    WELCOME TO {{ applicationName$ | async }}
  </div>
  <div class="d-flex flex-wrap py-2" [ngStyle]="{ 'justify-content': headerPictureURL ? '' : 'center' }">
    <div *ngIf="headerPictureURL" class="px-2">
      <div class="logo_button d-flex justify-content-center align-items-center" style="width: 240px; height: auto; background-color: grey">
        <img [src]="headerPictureURL" alt="Logo" style="width: 240px; height: auto; background-color: grey" />
      </div>
    </div>

    <div class="d-flex justify-content-center p-4">
      <div
        class="d-flex p-1 justify-content-center align-items-center"
        [innerHTML]="helpMessage"
        [ngStyle]="{ 'text-align': headerPictureURL ? 'left' : 'center' }"
      ></div>
    </div>
  </div>
  <div class="card-wrapper">
    <app-help-you-sell class="card-container"></app-help-you-sell>
    <app-central-tasks  *ngIf="(arbCentralSecurityFunctions$ | async)?.manageTicketsActionTF" class="card-container"></app-central-tasks>

    <!-- <app-product-info-bulletin-email
      class="card-container"
      [isExternalUser]="isExternalUser$ | async"
      [isProgrammeUser]="isProgrammeUser$ | async"
    ></app-product-info-bulletin-email>

    <app-internal-bulletin-email
      *ngIf="!(isExternalUser$ | async) && !(isProgrammeUser$ | async)"
      class="card-container"
      [isExternalUser]="isExternalUser$ | async"
      [isProgrammeUser]="isProgrammeUser$ | async"
    ></app-internal-bulletin-email> -->

    <app-help-how-to class="card-container" [helpHowToComponent]="helpHowToComponent"></app-help-how-to>
  </div>
</div>
